import React, {
  forwardRef,
  useRef,
} from 'react';

import classNames from 'classnames';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { IReduxState } from 'ReduxState';

import { GetStaffPortalStore } from 'SessionState/Staff/StaffPortalStore';

import {
  MENU_BEHAVIOUR,
  MENU_PLACEMENT,
} from 'constants.js';

import {
  menuChangeAttrMenuAnimate,
  menuChangeCollapseAll,
} from './main-menu/menuSlice';

import useCustomLayout from 'hooks/useCustomLayout';
import StaffNavIconMenu from './StaffNavIconMenu';
import StaffNavLogo from './StaffNavLogo';



type StaffNavProps = {
  children?: React.ReactNode;

  className?: string;

  onLogout?: () =>
    void | Promise<void>;
};

const StaffNav = forwardRef<
  HTMLDivElement,
  StaffNavProps
>(
  (
    {
      children,
      className,
      onLogout,
    },
    ref,
  ) => {
    const {
      navClasses,
      placementStatus,
      behaviourStatus,
      attrMobile,
      menuPadding,
    } = useSelector(
      (state: IReduxState) =>
        state.menu,
    );

    const dispatch =
      useDispatch();

    const mouseActionTimer =
      useRef(null);

    const staffStore =
      GetStaffPortalStore();

    const tabulator =
      staffStore.CurrentTabulator;

    const dashboard =
      staffStore.ReadOnlyDashboard;

    const isLoggedIn =
      !!tabulator;

    useCustomLayout({
      placement:
        MENU_PLACEMENT.Vertical,
    });

    const onMouseEnterDelay =
      () => {
        if (
          placementStatus
            .placementHtmlData ===
            MENU_PLACEMENT.Vertical &&
          behaviourStatus
            .behaviourHtmlData ===
            MENU_BEHAVIOUR.Unpinned &&
          attrMobile !== true
        ) {
          dispatch(
            menuChangeCollapseAll(
              false,
            ),
          );

          dispatch(
            menuChangeAttrMenuAnimate(
              'show',
            ),
          );
        }
      };

    return (
      <div
        ref={ref}
        id="nav"
        className={classNames(
          'nav-container d-flex',
          navClasses,
          className,
        )}
      >
        <div
          className="nav-content d-flex justify-content-between"
          style={
            placementStatus
              .placementHtmlData ===
                MENU_PLACEMENT.Horizontal &&
            menuPadding
              ? {
                  paddingRight:
                    menuPadding,
                }
              : {}
          }
        >
          <StaffNavLogo
           />

          {isLoggedIn && (
            <div className="d-none d-md-flex flex-column align-items-center justify-content-center text-center">
              <div className="fw-bold fs-5 text-body">
                {dashboard?.eventName ??
                  'Staff Portal'}
              </div>
            </div>
          )}

          <div className="d-flex align-items-start justify-content-end">
            {isLoggedIn ? (
              <StaffNavIconMenu
                onLogout={
                  onLogout
                }
              />
            ) : (
              <div className="fw-bold fs-5 text-body">
                STAFF PORTAL
              </div>
            )}
          </div>

          {children && (
            <div className="pb-2">
              {children}
            </div>
          )}
        </div>
      </div>
    );
  },
);

StaffNav.displayName =
  'StaffNav';

export default React.memo(
  StaffNav,
);